import { useEffect, useState } from "react";
import "./App.css";
import "add-to-calendar-button";
import { closeOverlay, handleEsc, closeModal } from "./Modal";

const gigs = [
  {
    date: "2025/06/07",
    html: (
      <li className="event-listing">
        <div className="date-box">
          <h4 className="month">June</h4>
          <h3 className="date">7</h3>
          <h5 className="year">2025</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://www.thegreengrowler.com/events"
              target="_blank"
              rel="nofollow"
            >
              GREEN GROWLER
            </a>
          </strong>
          <p className="secondary-detail">SATURDAY 7 - 10 PM</p>

          <add-to-calendar-button
            name="New Moon Recruit Live at The Green Growler"
            description="https://www.thegreengrowler.com/events"
            startDate="2025-06-07"
            startTime="19:00"
            endTime="22:00"
            location="Green Growler, 4 Croton Point Avenue, Croton on Hudson, NY 10520, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
  {
    date: "2025/08/23",
    html: (
      <li className="event-listing">
        <div className="date-box">
          <h4 className="month">August</h4>
          <h3 className="date">23</h3>
          <h5 className="year">2025</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://hardscrabbleciderny.com/cider-nights-2025"
              target="_blank"
              rel="nofollow"
            >
              HARVEST MOON FARM AND ORCHARD
            </a>
          </strong>
          <p className="secondary-detail">SATURDAY 6 - 9 PM</p>

          <add-to-calendar-button
            name="New Moon Recruit Live at Harvest Moon Farm and Orchard"
            description="https://hardscrabbleciderny.com/cider-nights-2025"
            startDate="2025-08-23"
            startTime="18:00"
            endTime="21:00"
            location="Harvest Moon Farm & Orchard, 130 Hardscrabble Rd, North Salem, NY 10560, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
  {
    date: "2025/09/13",
    html: (
      <li className="event-listing">
        <div className="date-box">
          <h4 className="month">September</h4>
          <h3 className="date">13</h3>
          <h5 className="year">2025</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://boscosgrill.com/old-greenwich-bosco-s-bar-and-grill-events/"
              target="_blank"
              rel="nofollow"
            >
              BOSCO'S BAR AND GRILL
            </a>
          </strong>
          <p className="secondary-detail">SATURDAY 8 - 12 AM</p>

          <add-to-calendar-button
            name="New Moon Recruit Live at Boscos Bar and Grill"
            description="https://boscosgrill.com/old-greenwich-bosco-s-bar-and-grill-events/"
            startDate="2025-09-13"
            startTime="20:00"
            endTime="23:59"
            location="Boscos Bar and Grill, 148 Sound Beach Avenue, Old Greenwich, CT 06870, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
  {
    date: "2025/06/14",
    html: (
      <li className="event-listing">
        <div className="date-box">
          <h4 className="month">June</h4>
          <h3 className="date">14</h3>
          <h5 className="year">2025</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://www.outhouseorchardsny.com/fall-festival-1"
              target="_blank"
              rel="nofollow"
            >
              OUTHOUSE ORCHARDS
            </a>
          </strong>
          <p className="secondary-detail">SATURDAY 5:30 - 9 PM</p>

          <add-to-calendar-button
            name="New Moon Recruit Live at Outhouse Orchards"
            description="https://www.outhouseorchardsny.com/fall-festival-1"
            startDate="2025-06-14"
            startTime="17:30"
            endTime="21:00"
            location="Outhouse Orchards, 139 Hardscrabble Rd, North Salem, NY 10560, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
  {
    date: "2025/06/15",
    html: (
      <li className="event-listing">
        <div className="date-box">
          <h4 className="month">June</h4>
          <h3 className="date">15</h3>
          <h5 className="year">2025</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://www.captainlawrencebrewing.com/mt-kisco/events/"
              target="_blank"
              rel="nofollow"
            >
              CAPTAIN LAWRENCE BREWING CO.
            </a>
          </strong>
          <p className="secondary-detail">SATURDAY 2 - 3:30 PM</p>

          <add-to-calendar-button
            name="New Moon Recruit Live at Captain Lawrence Brewing Co. Mt. Kisco"
            description="https://www.captainlawrencebrewing.com/mt-kisco/events/"
            startDate="2025-06-15"
            startTime="14:00"
            endTime="15:30"
            location="Captain Lawrence Barrel House, 369 Lexington Ave, Mt Kisco, NY 10549, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
  {
    date: "2025/06/27",
    html: (
      <li className="event-listing">
        <div className="date-box">
          <h4 className="month">June</h4>
          <h3 className="date">27</h3>
          <h5 className="year">2025</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://boscosgrill.com/old-greenwich-bosco-s-bar-and-grill-events/"
              target="_blank"
              rel="nofollow"
            >
              BOSCO'S BAR AND GRILL
            </a>
          </strong>
          <p className="secondary-detail">SATURDAY 8 - 12 AM</p>

          <add-to-calendar-button
            name="New Moon Recruit Live at Boscos Bar and Grill"
            description="https://boscosgrill.com/old-greenwich-bosco-s-bar-and-grill-events/"
            startDate="2025-06-27"
            startTime="20:00"
            endTime="23:59"
            location="Boscos Bar and Grill, 148 Sound Beach Avenue, Old Greenwich, CT 06870, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },

  {
    date: "2025/05/17",
    html: (
      <li className="event-listing">
        <div className="date-box">
          <h4 className="month">May</h4>
          <h3 className="date">17</h3>
          <h5 className="year">2025</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://hardscrabbleciderny.com/cider-nights-2025"
              target="_blank"
              rel="nofollow"
            >
              HARVEST MOON FARM AND ORCHARD
            </a>
          </strong>
          <p className="secondary-detail">SATURDAY 6 - 9 PM</p>

          <add-to-calendar-button
            name="New Moon Recruit Live at Harvest Moon Farm and Orchard"
            description="https://hardscrabbleciderny.com/cider-nights-2025"
            startDate="2025-05-17"
            startTime="18:00"
            endTime="21:00"
            location="Harvest Moon Farm & Orchard, 130 Hardscrabble Rd, North Salem, NY 10560, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
  {
    date: "2024/05/11",
    html: (
      <li className="event-listing">
        <div className="date-box">
          <h4 className="month">May</h4>
          <h3 className="date">11</h3>
          <h5 className="year">2024</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://hardscrabbleciderny.com/cider-nights-2024-1"
              target="_blank"
              rel="nofollow"
            >
              HARVEST MOON FARM AND ORCHARD
            </a>
          </strong>
          <p className="secondary-detail">SATURDAY 6 - 9 PM</p>

          <add-to-calendar-button
            name="New Moon Recruit Live at Harvest Moon Farm and Orchard"
            description="https://hardscrabbleciderny.com/cider-nights-2024-1"
            startDate="2024-05-11"
            startTime="18:00"
            endTime="21:00"
            location="Harvest Moon Farm & Orchard, 130 Hardscrabble Rd, North Salem, NY 10560, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
  {
    date: "2024/06/15",
    html: (
      <li className="event-listing ">
        <div className="date-box">
          <h4 className="month">June</h4>
          <h3 className="date">15</h3>
          <h5 className="year">2024</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://www.captainlawrencebrewing.com/brewery-events/"
              target="_blank"
              rel="nofollow"
            >
              CAPTAIN LAWRENCE BREWING CO.
            </a>
          </strong>
          <p className="secondary-detail">SATURDAY 2 PM</p>
          <add-to-calendar-button
            name="New Moon Recruit Live at Captain Lawerence Brewing Co."
            /*description="HARVEST MOON FARM AND ORCHARD"*/
            startDate="2024-06-15"
            startTime="14:00"
            endTime="16:00"
            location="Captain Lawrence Barrel House, 369 Lexington Ave, Mt Kisco, NY 10549, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
  {
    date: "2024/07/26",
    html: (
      <li className="event-listing ">
        <div className="date-box">
          <h4 className="month">July</h4>
          <h3 className="date">26</h3>
          <h5 className="year">2024</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://hardscrabbleciderny.com/cider-nights-2024-1"
              target="_blank"
              rel="nofollow"
            >
              HARVEST MOON FARM AND ORCHARD
            </a>
          </strong>
          <p className="secondary-detail">FRIDAY 6 - 9 PM</p>
          <add-to-calendar-button
            name="New Moon Recruit Live at Harvest Moon Farm and Orchard"
            /*description="HARVEST MOON FARM AND ORCHARD"*/
            startDate="2024-07-26"
            startTime="18:00"
            endTime="21:00"
            location="Harvest Moon Farm & Orchard, 130 Hardscrabble Rd, North Salem, NY 10560, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
  {
    date: "2024/08/23",
    html: (
      <li className="event-listing ">
        <div className="date-box">
          <h4 className="month">August</h4>
          <h3 className="date">23</h3>
          <h5 className="year">2024</h5>
        </div>
        <div className="event-details concert">
          <strong className="primary-detail">
            <a
              href="https://hardscrabbleciderny.com/cider-nights-2024-1"
              target="_blank"
              rel="nofollow"
            >
              HARVEST MOON FARM AND ORCHARD
            </a>
          </strong>
          <p className="secondary-detail">FRIDAY 6 - 9 PM</p>
          <add-to-calendar-button
            name="New Moon Recruit Live at Harvest Moon Farm and Orchard"
            /*description="HARVEST MOON FARM AND ORCHARD"*/
            startDate="2024-08-23"
            startTime="18:00"
            endTime="21:00"
            location="Harvest Moon Farm & Orchard, 130 Hardscrabble Rd, North Salem, NY 10560, USA"
            options="['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']"
            timeZone="US/Eastern"
            trigger="click"
            listStyle="dropdown"
            iCalFileName="Reminder-Event"
            lightMode="dark"
          />
        </div>
      </li>
    ),
  },
];
const upcomingGigs = [];

const pastGigs = [];

// Get the current date in milliseconds
const now = +new Date(); // for example: 1715388610476

for (const currentGigInLoop of gigs) {
  const currGigDate = +new Date(currentGigInLoop.date);

  if (currGigDate < now) {
    pastGigs.push(currentGigInLoop.html);
  } else {
    upcomingGigs.push(currentGigInLoop.html);
  }
}

function App() {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    /* const timer = setTimeout(() => {
      setModalOpen(true);
    }, 5000); // 3 seconds

    return () => clearTimeout(timer); */
  }, []);

  useEffect(() => {
    if (modalOpen) {
      document.addEventListener("keydown", handleEsc);
    } else {
      document.removeEventListener("keydown", handleEsc);
    }
    return () => document.removeEventListener("keydown", handleEsc);
  }, [modalOpen]);

  // Helper to close modal and update state
  const handleCloseModal = (evt) => {
    setModalOpen(false);
    closeModal(evt);
  };

  return (
    <div className="App">
      <nav
        className="navbar navbar-expand-lg navbar-dark fixed-top py-lg-0 px-0 px-lg-0 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <a href="#" className="logotext navbar-brand">
          NEW MOON RECRUIT
        </a>
        <button
          type="button"
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse py-4 py-lg-0"
          id="navbarCollapse"
        >
          <div className="navbar-nav ms-auto">
            <a href="#bio" className="nav-item nav-link">
              Bio
            </a>
            <a href="#gigs" className="nav-item nav-link">
              Gigs
            </a>
            <a href="#videos" className="nav-item nav-link">
              Videos
            </a>
            <a href="#photos" className="nav-item nav-link">
              Photos
            </a>
            <a href="#socials" className="nav-item nav-link">
              Socials
            </a>
            <a
              href="mailto:newmoonrecruit@gmail.com"
              target="_blank"
              className="nav-item nav-link"
            >
              Contact
            </a>
          </div>
          {/*<a href="" className="btn btn-primary"
          >Buy Ticket<i className="fa fa-arrow-right ms-3"></i
          ></a>*/}
        </div>
      </nav>

      <div className="big-image-container container-fluid bg-dark p-0 mb-5">
        <div className="row g-0 flex-column-reverse flex-lg-row">
          <div className="col-lg-12 p-0 wow fadeIn" data-wow-delay="0.1s">
            <a href="/" className="navbar-brand p-0">
              <img
                className="img-fluid-main me-3 logo"
                src="img/smiley-face.jpg"
                alt="NMR Logo"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="bio-container container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <h1 className="display-5 mb-4"></h1>
              <a name="bio" className="anchor"></a>
              <h2 className="text-primary">WHO WE ARE</h2>
              <div>
                New Moon Recruit, commonly referred to as NMR, is a NY-based
                rock trio serving up original compositions and classic covers.
                As experienced musicians in both technique and improvisation,
                NMR has been slaying at venues, events, and private functions
                throughout the tri-state area for the past 5 years. Their blend
                of energetic music has captivated and entertained audiences
                alike.
              </div>
              <h2 className="text-secondary">FEATURING</h2>
              <h5 className="mb-3">
                {/* <i className="far fa-check-circle text-primary me-3"></i> */}
                <a
                  className="band-member-text"
                  href="http://www.instagram.com/bigjimspecial"
                  target="_blank"
                >
                  Jimi Olimpieri
                </a>{" "}
                - Guitar/Vocals
              </h5>
              <h5 className="mb-3">
                {/* <i className="far fa-check-circle text-primary me-3"></i> */}
                <a
                  className="band-member-text"
                  href="http://www.instagram.com/zachmarksdrums"
                  target="_blank"
                >
                  Zach Marks
                </a>{" "}
                - Drums/Percussion
              </h5>
              <h5 className="mb-3">
                {/* <i className="far fa-check-circle text-primary me-3"></i> */}
                <a
                  className="band-member-text"
                  href="http://www.instagram.com/adam_marianacci"
                  target="_blank"
                >
                  Adam Marianacci
                </a>{" "}
                - Bass
              </h5>
              <h5 className="mb-3"></h5>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <img className="img-fluid" src="img/Bestlogo.JPG" alt="" />
            </div>
          </div>
        </div>
      </div>

      <a id="gigs" className="anchor"></a>
      <div
        className="gigs container-xxl bg-primary visiting-hours my-5 py-5 wow fadeInUp NMRBanner"
        data-wow-delay="0.1s"
      >
        {upcomingGigs.length > 0 ? (
          <div className="main-text">Upcoming Gigs</div>
        ) : (
          <div className="main-text">Check back soon for Upcoming Gigs</div>
        )}

        <ol className="event-listings artist-gigography-summary ">
          {upcomingGigs}
        </ol>

        {pastGigs.length > 0 ? (
          <div id="pastGigsAccordion">
            <div>
              <div
                className="main-text"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Past Gigs
              </div>
              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                data-bs-parent="#pastGigsAccordion"
              >
                <div>
                  <ol className="event-listings artist-gigography-summary past-gigs-list">
                    {pastGigs}
                  </ol>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      <div className="youtube-container container-fluid p-0 mb-5">
        <div className="row g-0 flex-column-reverse flex-lg-row">
          <div className="col-lg-12 p-0 wow fadeIn" data-wow-delay="0.1s">
            <div className="header-bg h-100 d-flex flex-column justify-content-center">
              <a name="videos" className="anchor"></a>

              <div className="videoWrapper">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/DyOFgkMhXU0?si=yV2ksrhKUxtMMrKS"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>

                <iframe
                  width="916"
                  height="515"
                  src="https://www.youtube.com/embed/zG4iXLEg45k"
                  title="New Moon Recruit Live at Harvest Moon"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-med>ia; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>

                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/iLyN9GZTuo0?si=SpGqXMZUTmnxVsqM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>

                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/yCX0PbeH_Wg?si=2UIKjwOmMsp2xE_4"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a name="photos" className="anchor"></a>
      <div className="photos-container container-xxl py-5">
        <div className="container">
          <div className="row g-4">
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="row g-4">
                <div className="col-12">
                  <a
                    className="animal-item"
                    href="img/adam.jpg"
                    data-lightbox="animal"
                  >
                    <div className="position-relative">
                      <img className="img-fluid" src="img/adam.jpg" alt="" />
                      <div className="animal-text p-4">
                        {/* <p className="text-white small text-uppercase mb-0">Band Member</p> */}
                        {/* <h5 className="text-white mb-0">Adam</h5> */}
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-12">
                  <a
                    className="animal-item"
                    href="img/Jimi Face.JPEG"
                    data-lightbox="animal"
                  >
                    <div className="position-relative">
                      <img
                        className="img-fluid"
                        src="img/Jimi Face.JPEG"
                        alt="Jimi Stank Face"
                      />
                      <div className="animal-text p-4">
                        {/* <p className="text-white small text-uppercase mb-0">Band Member</p> */}
                        {/* <h5 className="text-white mb-0">Jimi</h5> */}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="row g-4">
                <div className="col-12">
                  <a
                    className="animal-item"
                    href="img/Zach.JPEG"
                    data-lightbox="animal"
                  >
                    <div className="position-relative">
                      <img
                        className="img-fluid"
                        src="img/Zach.JPEG"
                        alt="Zach"
                      />
                      <div className="animal-text p-4">
                        {/* <p className="text-white small text-uppercase mb-0">Band Member</p> */}
                        {/* <h5 className="text-white mb-0">Zach</h5> */}
                      </div>
                    </div>
                  </a>
                </div>

                <div className="col-12">
                  <a
                    className="animal-item"
                    href="img/jimi.jpg"
                    data-lightbox="animal"
                  >
                    <div className="position-relative">
                      <img
                        className="img-fluid"
                        src="img/jimi.jpg"
                        alt="Jimi"
                      />
                      <div className="animal-text p-4">
                        {/* <p className="text-white small text-uppercase mb-0">Band Member</p> */}
                        {/* <h5 className="text-white mb-0">Jimi</h5> */}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="row g-4">
                <div className="col-12">
                  <a
                    className="animal-item"
                    href="img/ryan.jpg"
                    data-lightbox="animal"
                  >
                    <div className="position-relative">
                      <img className="img-fluid" src="img/ryan.jpg" alt="" />
                      <div className="animal-text p-4">
                        {/* <p className="text-white small text-uppercase mb-0">Band Member</p> */}
                        {/* <h5 className="text-white mb-0">Jimi</h5> */}
                      </div>
                    </div>
                  </a>
                </div>

                <div className="col-12">
                  <a
                    className="animal-item"
                    href="img/Adam.JPEG"
                    data-lightbox="animal"
                  >
                    <div className="position-relative">
                      <img
                        className="img-fluid"
                        src="img/Adam.JPEG"
                        alt="Adam"
                      />
                      <div className="animal-text p-4">
                        {/* <p className="text-white small text-uppercase mb-0">Band Member</p> */}
                        {/* <h5 className="text-white mb-0">Adam</h5> */}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="socials"
        className="social-container container-fluid footer text-light footer wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-12">
              <div className="d-flex pt-2 socialmediaicons">
                <a
                  className="btn btn-outline-light btn-social"
                  href="mailto:newmoonrecruit@gmail.com"
                  target="_blank"
                >
                  <i className="fas fa-envelope"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  href="https://www.instagram.com/newmoonrecruit"
                  target="_blank"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  href="https://www.youtube.com/@NewMoonRecruit"
                  target="_blank"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  href="https://www.venmo.com/u/newmoonrecruit"
                  target="_blank"
                >
                  <i className="fab fa-vimeo"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-12 text-center text-md-start mb-3 mb-md-0">
                &copy; 2025 New Moon Recruit, All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal${modalOpen ? " modal_opened" : ""}`}
        id="preview-modal"
        onClick={closeOverlay}
        // style={{ display: modalOpen ? "block" : "none" }}
      >
        <div className="modal__container modal__container_type_preview">
          <button
            type="button"
            className="modal__close-button modal__close-button_type_preview"
            onClick={handleCloseModal}
          ></button>
          <img
            className="modal__image"
            src="../img/Boscos-gig-flyer_3.png"
            alt="Bosco's Gig Flyer"
          />
          <p className="modal__caption"></p>
        </div>
      </div>

      <a href="#" className="btn btn-lg btn-primary btn-lg-square back-to-top">
        <i className="bi bi-arrow-up"></i>
      </a>
    </div>
  );
}

export default App;
